<template>
  <div>
    <div class="page-title">新申請 New Admission</div>
    <div class="application-detail">
      <div style="white-space: pre-wrap;"
        v-if="applicationDetail.eventStatus"
        class="ad-fs-title">Registration No {{ applicationDetail.registrationNo }}</div>
      <div
        style="white-space: pre-wrap;"
        v-if="applicationDetail.eventStatus"
        class="fs-title"
      >
        {{ applicationDetail.eventStatus.title }}
      </div>
      <div class="application-content">
        <applicationView v-if="applicationDetail" :id="id" :type="formType"  :studentPerformance="studentPerformance" :studentFiles="studentFiles" :declaration="declaration" :parentParticularData="parentParticularData" :personalBackground="personalBackground" :studentParticular="studentParticular" :adminEdit="true" :applicationDetail="applicationDetail"></applicationView>
        <el-button @click="onSubmit" type="primary"> Submit </el-button>
      </div>
      <copyrightCard></copyrightCard>
    </div>
  </div>
</template>

<script>
import applicationView from "@/components/applicationView";
import {
  getApplicationDetail,
  putApplicationDetail,
} from "@/api/admin/application";
import copyrightCard from "@/components/copyrightCard";
import applicationFormat from "@/utils/applicationFormat.js";
export default {
  mixins: [applicationFormat],
  components: {
    applicationView,
    copyrightCard,
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      parentParticularData:{
        parentParticulars: []
      },
      personalBackground:{},
      studentFiles:[],
      questionnaire:{
        questionnaires:[]
      },
      subjectsApplied:{},
      declaration:{},
      studentPerformance:{},
      studentParticular:{},
      applicationDetail: {},
      applicationId: 0,
      formType: 0,
    };
  },
  mounted() {
    this.int();
  },
  methods: {
    int() {
      this.formType = this.type;
      this.applicationId = this.id;
      this.isEditGetApplicationDetail();
    },
    isEditGetApplicationDetail() {
      getApplicationDetail(this.applicationId).then((v) => {
        this.applicationDetail = v.data;
        this.$nextTick(() => {
        this.studentParticular =Object.assign({},this.studentParticular,JSON.parse(
          this.componentMethods(v.data.components, 0)||'{}'
        ));
        this.parentParticularData.parentParticulars = Object.assign([],this.parentParticularData.parentParticulars,JSON.parse(
          this.componentMethods(v.data.components, 1)||'[]'));
        this.personalBackground = Object.assign({},this.personalBackground,JSON.parse(
          this.componentMethods(v.data.components, 2)||'{}'
        ));
        this.studentFiles = Object.assign([],this.studentFiles,JSON.parse(
          this.componentMethods(v.data.components, 3)||'{}'
        ));
        this.questionnaire.questionnaires = Object.assign([],this.questionnaire.questionnaires,JSON.parse(
          this.componentMethods(v.data.components, 4)||'[]'
        ));
        this.applicantLanguage.applicantLanguages = Object.assign([],this.applicantLanguage.applicantLanguages,JSON.parse(
          this.componentMethods(v.data.components, 5)||'[]'
        ))
        this.subjectsApplied = Object.assign({},this.subjectsApplied,JSON.parse(
          this.componentMethods(v.data.components, 6)||'{}'
        ));
        this.declaration = Object.assign({},this.declaration,JSON.parse( this.componentMethods(v.data.components, 7)||'{}'
        ));
        this.studentPerformance = Object.assign({},this.studentPerformance,JSON.parse( this.componentMethods(v.data.components, 8)||'{}'
        ))
        });
        // this.personalBackground = JSON.parse(
        //   this.componentMethods(v.data.components, 2)||'{}'
        // );
        // this.studentFiles = JSON.parse(
        //   this.componentMethods(v.data.components, 3)||'{}'
        // );
        // this.questionnaire.questionnaires = JSON.parse(
        //   this.componentMethods(v.data.components, 4)||'{}'
        // );
        // this.applicantLanguage.applicantLanguages = JSON.parse(
        //   this.componentMethods(v.data.components, 5)||'{}'
        // );
        // this.subjectsApplied = JSON.parse(
        //   this.componentMethods(v.data.components, 6)||'{}'
        // );
        // this.declaration = JSON.parse(
        //   this.componentMethods(v.data.components, 7)||'{}'
        // );
        //  this.studentPerformance = JSON.parse(
        //   this.componentMethods(v.data.components, 8)||'{}'
        // );
        this.$forceUpdate();
      });
    },
    componentMethods(components, type) {
      return components.filter((v) => {
        return v.type == type;
      })[0]?.value;
    },
    onSubmit() {
      this.putApplicationDetail();
    },
    putApplicationDetail() {
      this.setSiblingsIdentityDocument()
      let from = [
        {
          type: 8,
          value: JSON.stringify(this.studentPerformance),
        },
        {
          type: 7,
          value: JSON.stringify(this.declaration),
        },
        {
          type: 0,
          value: JSON.stringify(this.studentParticular),
        },
        {
          type: 1,
          value: JSON.stringify(this.parentParticularData.parentParticulars),
        },
        {
          type: 2,
          value: JSON.stringify(this.personalBackground),
        },
        {
          type: 3,
          value: JSON.stringify(this.studentFiles),
        },
        {
          type: 4,
          value: JSON.stringify(this.questionnaire.questionnaires),
        },
        {
          type: 5,
          value: JSON.stringify(this.applicantLanguage.applicantLanguages),
        },
        {
          type: 6,
          value: JSON.stringify(this.subjectsApplied),
        },
      ];
      putApplicationDetail(this.applicationId, from).then(() => {
        this.$message.success("Set successfully.");
      });
    },
    setSiblingsIdentityDocument(){
      if(this.studentParticular.siblingsIdentityDocument.isHas){
        this.studentParticular.siblingsIdentityDocument.siblings.map((v)=>{
           if(v.type == 0){
             v.certificateNo = v.certificateNoTop  + v.certificateNoCont  + v.certificateNoBottom;
           }
           return v
        })
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.application-detail {
  background-color: #fff;
  padding-top: 60px;
}
.application-content {
  padding: 0 60px;
}
.el-breadcrumb {
  margin: 30px 0;
}
.dialog-title {
  font-size: 20px;
}
.dialog-text {
  font-size: 16px;
}
::v-deep {
  .el-breadcrumb__item:first-child .el-breadcrumb__inner {
    color: #0064ed;
  }
  .el-button--primary {
    width: auto;
    background-color: #0962fa;
    border-color: #0962fa;
    font-size: 20px;
    font-weight: bold;
  }
}
</style>